<template>
  <div class="animated">
    <analyte-table
      :analytes="analytes"
      :show_columns="[
        'name',
        'abbrev',
      ]"
    />
  </div>
</template>

<script>
import AnalyteTable from '@/components/lab/analyte/AnalyteTable'

export default {
  name: 'SampleAnalyteTable',
  components: {
    AnalyteTable
  },
  props: {
    analytes: {
      type: Array,
      default: () => []
    }
  }
}
</script>
